import React from 'react';

import {
	CICDIcon,
	CloudIcon,
	CommitChangeIcon,
	GearIcon,
	TriggerBuildIcon,
	NotifyBuildIcon,
	BuildIcon,
	RunTestsIcon,
	NotifyTestIcon,
	DeliverBuildIcon,
	DeployIcon,
} from '@components/icons';

import IaaSImage from '@static/images/figures/iaas.webp';
import PaaSImage from '@static/images/figures/paas.webp';
import SaaSImage from '@static/images/figures/saas.webp';

import JenkinsIcon from '@images/icons/technologies/jenkins.svg';
import DockerIcon from '@images/icons/technologies/docker.svg';
import AWSIcon from '@images/icons/technologies/aws.svg';
import ProxyIcon from '@images/icons/technologies/proxy.svg';
import DNSIcon from '@images/icons/technologies/dns.svg';
import AnsibleIcon from '@images/icons/technologies/ansible.svg';

import SprintIcon from '@images/icons/sprint.svg';
import TestingIcon from '@static/images/icons/testing-icon.svg';
import CustomSoftwareIcon from '@static/images/icons/development-icon.svg';

import { PageUrls } from '@utils/constants/PageUrls';

export const anchors = [
	{
		icon: <CICDIcon />,
		title: 'CD/CI',
		link: '#pipeline',
	},
	{ icon: <CloudIcon />, title: 'Cloud', link: '#cloud' },
	{
		icon: <GearIcon />,
		title: 'Technologies',
		link: '#technologies',
	},
];

export const pipeline = [
	{
		Icon: CommitChangeIcon,
		text: 'Commit change',
	},
	{
		Icon: TriggerBuildIcon,
		text: 'Trigger build',
	},
	{
		Icon: BuildIcon,
		text: 'Build',
	},
	{
		Icon: NotifyBuildIcon,
		text: 'Notify of build outcome',
	},
	{
		Icon: RunTestsIcon,
		text: 'Run tests',
	},
	{
		Icon: NotifyTestIcon,
		text: 'Notify of test outcome',
	},
	{
		Icon: DeliverBuildIcon,
		text: 'Deliver build to staging',
	},
	{
		Icon: DeployIcon,
		text: 'Deploy to Production',
	},
];

export const cloudServices = [
	{
		icon: IaaSImage,
		title: 'IaaS',
		subtitle: 'Infrastructure as a Service',
		description:
			'It is a paradigm similar to the traditional data center setup in which you are given machines and are in charge of maintaining them remotely. You supply your own licenses, software, and services to the servers in this approach, while the cloud provider is only responsible for the hardware, the network, storage and virtualization of your assigned machines.',
	},
	{
		icon: PaaSImage,
		title: 'PaaS',
		subtitle: 'Platform as a Service',
		description:
			'This model goes a little further than IaaS because the cloud provider is also in charge of the middleware, such as application servers or API connectors, and the operating system that runs on the deployed servers. ',
	},
	{
		icon: SaaSImage,
		title: 'SaaS',
		subtitle: 'Software as a Service',
		description:
			'This model is the most comprehensive and delves deep into your business operations. Software as a Service, or SaaS, is a term used to describe how you pay for the use of software without having to worry about infrastructure or even software problems.',
	},
];

export const weWorkWithData = [
	{
		icon: JenkinsIcon,
		name: 'Jenkins',
	},
	{
		icon: DockerIcon,
		name: 'Docker',
	},
	{
		icon: AWSIcon,
		name: 'AWS',
	},
	{
		icon: ProxyIcon,
		name: 'Proxy',
	},
	{
		icon: DNSIcon,
		name: 'DNS',
	},
	{
		icon: AnsibleIcon,
		name: 'Ansible',
	},
];

export const internalLinkingData = [
	{
		icon: SprintIcon,
		title: 'How we work?',
		items: ['Development Flow', 'Weekly Sprints', 'Communication'],
		link: PageUrls.HOW_WE_WORK,
	},
	{
		icon: TestingIcon,
		title: 'Quality Assurance & Testing',
		items: ['Manual testing', 'Automated testing', 'Unit testing'],
		link: PageUrls.TESTING,
	},
	{
		icon: CustomSoftwareIcon,
		title: 'Custom Software Development',
		items: [
			{ title: 'Web Applications', subItems: ['Frontend', 'Backend'] },
			{ title: 'Mobile Applications', subItems: ['Native', 'Cross-platform'] },
		],
		link: PageUrls.DEVELOPMENT,
	},
];
